import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

import { IntegrationRepository } from '@/services/api/integration'
import type { IIntegrationConfiguration } from '@/types/IntegrationTypes'

export const useConfigurationStore = defineStore('configurationStore', () => {
  const integrationConfiguration = ref<IIntegrationConfiguration | null>(null)

  const isB2BConfiguration = computed(
    () => integrationConfiguration.value?.integrationType === 'B2B'
  )

  const getConfigurationConfig = async (): Promise<void> => {
    try {
      const { data } = await IntegrationRepository.getConfigurationConfig()
      integrationConfiguration.value = data
    } catch (e) {
      throw e
    }
  }

  return {
    integrationConfiguration,
    isB2BConfiguration,
    getConfigurationConfig,
  }
})
